module.exports = __webpack_public_path__ + "static/media/lamoderna_tresestrellas.add0fef1.png";